<template>
    <div class="timer_container">
        <span v-if="stylec == 0" :class="{ warn_ye: classh, warn_no: !classh }">
            {{
                type == 'close' ? $t('registerEvent.closed_registration') : (
                    `${
                        type == "now" ? $t("registerEvent.registration_will_close") : $t("registerEvent.registration_will_open")
                      } ${days}${$t("common.abbr_days")} ${hours}${$t("common.abbr_hours")} ${minutes}${$t("common.abbr_mins")} ${ seconds }${$t("common.abbr_secs")}`
                    )
            }}
        </span>
        <v-text-field v-if="stylec == 1 && classh == 1" outlined disabled
                      :value="timeRec" :label="labeltime"
                      class="input_str input_str_2 ldark warn_ye"
                      dense :hint="$t('registerEvent.warning_open')" persistent-hint>
        </v-text-field>
        <v-text-field v-if="stylec == 1 && classh == 0" outlined disabled
                      :value="timeRec" :label="labeltime"
                      class="input_str input_str_2 ldark warn_no"
                      dense :hint="$t('registerEvent.warning_not_open')" persistent-hint>
        </v-text-field>
    </div>
</template>
<script>
import { VTextField } from 'vuetify/lib';
import moment from 'moment-timezone';
export default {
    components: { VTextField },
    props: ['starttime', 'endtime', 'stylec', 'labeltime', 'classh', 'classLabel', 'type'],
    name: 'Timer',
    data(){
        return{
            now: moment(),
            classHint: ''
        }
    },
    mounted(){
        window.setInterval(() => {
            let time = moment().valueOf();
            this.now = Math.trunc(time / 1000);
        }, 1000);
    },
    computed:{
        timeRec(){
            if(this.days < 0)
                return "";
            if(this.days == 0 && this.hours == 0 && this.minutes == 0 && this.seconds == 0 && this.type != 'close') {
                this.$emit("changeType");
            }
            return this.days+"d "+this.hours+"h "+this.minutes+"m "+this.seconds+"s";
        },
        dateInMilliSeconds(){
            let tz = moment.tz.guess();
            let time = moment(this.endtime).tz(tz,true).valueOf();

            return Math.trunc(time / 1000);
        },
        seconds(){
            return Math.abs((this.dateInMilliSeconds - this.now) %60);
        },
        minutes(){
            return Math.abs(Math.trunc((this.dateInMilliSeconds - this.now)/60) % 60);
        },
        hours(){
            return Math.abs(Math.trunc((this.dateInMilliSeconds - this.now)/60/60) % 24);
        },
        days(){
            return Math.abs(Math.trunc((this.dateInMilliSeconds - this.now)/60/60/24));
        }
    },
    watch: {
        seconds(val) {
            if(this.days == 0 && this.hours == 0 && this.minutes == 0) {
                if(val == 0 || val > this.past){
                    this.$emit('changeType');
                }
                this.past = val;
            }
        }
    }
}
</script>
<style>
.timer {
  font-size: 20px;
  color: #fff;
  text-align:center;
  margin-top: 50px;
}

.day, .hour, .min, .sec {
    font-size: 30px;
    display: inline-block;
    font-weight: 500;
    text-align: center;
    margin: 0 5px;
}
.format {
    font-weight: 300;
    font-size: 14px;
    opacity: 0.8;
    width: 60px;
}
.number{
    background: rgba(51, 51, 51, 0.53);
    padding: 0 5px;
    border-radius: 5px;
    display: inline-block;
    width: 60px;
    text-align: center;
}
.ldark .v-text-field__slot input{
    color: #45615f !important;
    font-weight: bold;
}
.warn_no .v-messages__message{ color: red; }
.warn_ye .v-messages__message{ color: blue; }
span.warn_no { color: red; }
span.warn_ye { color: blue; }
</style>